// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarLayout_root__o8rkJ","header":"SidebarLayout_header__gfozn","container":"SidebarLayout_container__fGitD"};